import React from "react";

interface IHiddenLegends {
    hiddenLegends: any[];
    setHiddenLegends: any;
}

export const SegmentsSingleGraphLegendsContext = React.createContext<IHiddenLegends>({
    hiddenLegends: [],
    setHiddenLegends: () => {},
});
